import { Popover, UnstyledButton } from '@mantine/core';
import { DatePicker } from '@mantine/dates';
import dayjs from 'dayjs';
import { useState } from 'react';
import { TagChipBox } from './DocumentCard';

const DATE_FORMAT = 'YYYY-MM-DD';

type EditDocumentDateChipProps = {
  label: string;
  value: Date | null;
  maxDate: Date;
  onChange: (date: Date) => void;
};

export default function EditDocumentDateChip({
  label,
  value,
  maxDate,
  onChange,
}: EditDocumentDateChipProps) {
  const [opened, setOpened] = useState(false);

  const selectedDate = value ? dayjs(value).format(DATE_FORMAT) : null;

  const handleChange = (next: string | null) => {
    if (!next) return;
    onChange(new Date(`${dayjs(next).format(DATE_FORMAT)}T00:00:00Z`));
    setOpened(false);
  };

  return (
    <Popover
      opened={opened}
      onChange={setOpened}
      position="bottom-start"
      radius={12}
      shadow="xl"
      withinPortal
    >
      <Popover.Target>
        <UnstyledButton onClick={() => setOpened(prev => !prev)} aria-label={`Edit ${label}`}>
          <TagChipBox label={label} editable active={opened} />
        </UnstyledButton>
      </Popover.Target>
      <Popover.Dropdown p="xs">
        <DatePicker
          value={selectedDate}
          defaultDate={selectedDate ?? undefined}
          onChange={handleChange}
          maxDate={dayjs(maxDate).format(DATE_FORMAT)}
        />
      </Popover.Dropdown>
    </Popover>
  );
}
